//این تابع برای این نوشته شده است که زمان امروز یعنی مثلا 1400/2/30 را برگردوند
export function getNowTimes  () {
    const dateObj = new Date();
    let nowTime =  dateObj.getFullYear().toString()+'/'+(dateObj.getMonth()+1).toString()+'/'+ dateObj.getDate().toString()
    let moment = require('jalali-moment');
    let m = moment.from(nowTime, 'en', 'YYYY/MM/DD');
    return  m.locale('fa').format('YYYY/MM/DD');

}
export function getNowTimeWithHour (){
    const dateObj = new Date();
    let nowTime =  dateObj.getFullYear().toString()+'/'+(dateObj.getMonth()+1).toString()+'/'+ dateObj.getDate().toString()
    let moment = require('jalali-moment');
    let m = moment.from(nowTime, 'en', 'YYYY/MM/DD');
    return  m.locale('fa').format('YYYY/MM/DD') + ' ' + dateObj.getHours()+':'+dateObj.getMinutes()+':'+dateObj.getSeconds();
}
